import { AutoFixHigh, Bolt, Edit } from '@mui/icons-material';
import AIBannerBase from 'components/AI/AIBanner/AIBannerBase/AIBannerBase';
import {
  SECONDARY_TEXT_COLOR,
  SECONDARY_TEXT_COLOR_HOVER,
} from 'components/AI/AIStyles';

const FEATURES = [
  {
    id: 'auto-file-renaming',
    icon: <Edit />,
    label: 'Auto File Renaming',
    iconColor: SECONDARY_TEXT_COLOR_HOVER,
  },
  {
    id: 'auto-tagging',
    icon: <AutoFixHigh />,
    label: 'Auto-Tagging',
    iconColor: SECONDARY_TEXT_COLOR,
  },
  {
    id: 'instant-search',
    icon: <Bolt />,
    label: 'Instant Search',
    iconColor: '#EAB308',
  },
];

export const AIFilesBanner = () => (
  <AIBannerBase
    features={FEATURES}
    title="AI-Powered File Intelligence"
    description="Let our AI assistant automatically categorize, extract insights, and organize your files with magical precision."
  />
);
